(function (aimi_post_editor, $, app, undefined) {
  // Private object
  let __this = {};

  __this.postPlaceholder = '';

  function nl2br(str, replaceMode, isXhtml) {
    let breakTag = '<br>';
    let replaceStr = '$1' + breakTag + '$2';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
  }

  function br2nl(str) {
    if (_.isNull(str)) {
      return '';
    }
    let regex = /<br\s*[\/]?>/gi;
    return str.replace(regex, "\n")
  }


  aimi_post_editor.destroy = () => {
    const $container = $('.post-editor');
    $container.removeClass('with-design-library');
    $container.removeClass('with-image-library');
    $('.hk-pg-wrapper').removeClass('editor-with-image-library');
    $container.empty();

  }
  // Initialize Post Editor.
  aimi_post_editor.init = function (postId, activeSection) {
    const $container = $('.post-editor');
    const imageCssVar = 'post-editor-image-container-width';

    let post = app.clone(window.calendarPosts[postId]);

    post.text = !_.isUndefined(post.text) && !_.isNull(post.text) && !_.isEmpty(post.text) ? $.trim(br2nl(post.text)) : __this.postPlaceholder;
    post.twitter = !_.isUndefined(post.twitter) && !_.isNull(post.text) && !_.isEmpty(post.twitter) ? $.trim(br2nl(post.twitter)) : __this.postPlaceholder;
    //var post = {"id":"1019014","segments":{"Headline":["36507","Levate Marketing Returns: AI-Infused Data-Driven Crosschannel Mastery!","Levate Marketing Returns: AI-Infused Data-Driven Crosschannel Mastery!"],"Body":["36332","AIMI empowers you to eliminate operational inefficiencies, laying the foundation for exponential growth through intelligent automation.","AIMI empowers you to eliminate operational inefficiencies, laying the foundation for exponential growth through intelligent automation."],"Call to Action":["36439","Explore AIMI's capabilities for your business - schedule a demo now at {LINK|}.","Explore AIMI's capabilities for your business - schedule a demo now at https://aimiautomation.com/."]},"image":"https://acre-image-collections.s3.amazonaws.com/image-615b8ced16ea81633389805_medium.jpg","text":"Levate Marketing Returns: AI-Infused Data-Driven Crosschannel Mastery! AIMI empowers you to eliminate operational inefficiencies, laying the foundation for exponential growth through intelligent automation. Explore AIMI's capabilities for your business - schedule a demo now at https://aimiautomation.com/.  \n\n#AIMIContentAutomation #AI #AIMI","twitter":"AIMI empowers you to eliminate operational inefficiencies, laying the foundation for exponential growth through intelligent automation. Explore AIMI's capabilities for your business - schedule a demo now at https://aimiautomation.com/.  #AIMIContentAutomation #AI #AIMI","imageId":"72252","library":false,"pro":"https://acre-user-svgs.s3.amazonaws.com/6db309ad5d52b11ff58a75c8ef029e70.svg","proplus":"https://acre-user-svgs.s3.amazonaws.com/2f9d286b8c25221aeb54d9e667fa5411.svg","proTemplateId":"1633","proPlusTemplateId":"2571","mergeTags":{"Pro":{"{NAME|}":"AIMI","{CATEGORY_NAME|}":"AIMI General Promo","{COMPANY|}":"AIMI Automation","{USER_EMAIL|}":"aimi@prebuiltmarketing.com","{PRIMARY_COLOR|}":"#ffffff","{ACCENT_COLOR0|}":"#ffffff","{LOGO_COLOR|}":"transparent","{ACCENT_COLOR2|}":"#264653","{ACCENT_COLOR3|}":"#2A9D8F","{ACCENT_COLOR4|}":"#E9C46A","{ACCENT_COLOR5|}":"#F4A261","{ACCENT_COLOR6|}":"#000000","{FONT_TYPE|}":"Poppins","{FONT_COLOR|}":"#000000","{LINK|}":"https://aimiautomation.com/","{URL|}":"https://aimiautomation.com/","{FIRST_NAME|}":"Zach","{LAST_NAME|}":"Hedges","{IMAGE_LIBRARY|}":"https://acre-image-collections.s3.amazonaws.com/image-615b8ced16ea81633389805_medium.jpg","{BODY|}":"AIMI empowers you to eliminate operational inefficiencies, laying the foundation for exponential growth through intelligent automation.","{HEADLINE|}":"Levate Marketing Returns: AI-Infused Data-Driven Crosschannel Mastery!","{CTA|}":"Explore AIMI's capabilities for your business - schedule a demo now at https://aimiautomation.com/."},"Pro Plus":{"{NAME|}":"AIMI","{CATEGORY_NAME|}":"AIMI General Promo","{COMPANY|}":"AIMI Automation","{USER_EMAIL|}":"aimi@prebuiltmarketing.com","{PRIMARY_COLOR|}":"#ffffff","{ACCENT_COLOR0|}":"#ffffff","{LOGO_COLOR|}":"transparent","{ACCENT_COLOR2|}":"#264653","{ACCENT_COLOR3|}":"#2A9D8F","{ACCENT_COLOR4|}":"#E9C46A","{ACCENT_COLOR5|}":"#F4A261","{ACCENT_COLOR6|}":"#000000","{FONT_TYPE|}":"Poppins","{FONT_COLOR|}":"#000000","{LINK|}":"https://aimiautomation.com/","{URL|}":"https://aimiautomation.com/","{FIRST_NAME|}":"Zach","{LAST_NAME|}":"Hedges","{IMAGE_LIBRARY|}":"https://acre-image-collections.s3.amazonaws.com/image-615b8ced16ea81633389805_medium.jpg","{BODY|}":"AIMI empowers you to eliminate operational inefficiencies, laying the foundation for exponential growth through intelligent automation.","{HEADLINE|}":"Levate Marketing Returns: AI-Infused Data-Driven Crosschannel Mastery!","{CTA|}":"Explore AIMI's capabilities for your business - schedule a demo now at https://aimiautomation.com/."}},"plan":"proplus","dateScheduled":{"date":"2024-01-17 11:00:00.000000","timezone_type":3,"timezone":"America/Chicago"},"name":"Post #0","app_campaign_id":"28783","favorite":false,"imageSettings":null,"error":null,"networks":["facebook :: 789248874784961 :: AIMIsocial :: ayrshare-2 -- posted -- https://www.facebook.com/789248874784961_869511158513758","instagram ::  17841447620728165:: Zachary Hedges :: ayrshare-2 -- posted -- https://www.instagram.com/p/C2NdsO6xK0r/","linkedin  ::  27012206 :: corporate :: AIMI Content Automation :: ayrshare-2 -- posted -- https://www.linkedin.com/feed/update/urn:li:share:7153443485046468609","twitter  :: 322696284 :: AIMI Content Automation :: ayrshare-2 -- posted -- https://twitter.com/aimiapp/status/1747677829951611198"],"reminder":true,"status":"Posted","approvedStatus":"pending-review","app_campaign_name":"AIMI General Promo","d":"2024-01-17T11:00:00-06:00","schedulable":true,"postTimeCalendar":"2024-01-17T11:00:00","postDay":"2024-01-17","postDayTime":" 11:00 am","postEditorTime":"01/17/2024 11:00 AM"} ;

    __this.$postEditor = new PostEditor(app, $container, 'post-editor-image-container-width', activeSection);
    __this.$postEditor.setData(post);
    __this.$postEditor.render().then(function () {
      __this.observerManager = new ImageObserverManager(app, null, false);
      __this.$postEditor.setImageObserverManager(__this.observerManager);
      __this.$postEditor.observe();

      __this.$designLibrary = new DesignLibrary(app, $container);
      __this.$designLibrary.setData(post);
      __this.$designLibrary.setImageObserverManager(__this.observerManager);
    });

    __this.$postEditorInstance = __this.$postEditor.getInstance().editor;

    // Setup event listeners for tab navigation
    $(document).off("click.bs.pe-tab-navigation").on("click.bs.pe-tab-navigation", ".post-editor-container [data-bs-toggle], .design-library-container [data-bs-toggle]", function (e) {
      const $activeNav = $(this);
      __this.activeTab = $activeNav.attr('href');
      __this.$acitveTabContent = $(`${__this.activeTab}`);
      if (__this.activeTab === '#tab_history') {

      } else {
        if (__this.activeTab === '#tab_content_analysis') {

        }
      }

      if (__this.activeTab === '#tab_design_library_your_brand') {
        Utils.createAndShowTab('#tab_your_brand');
      }

      if (__this.activeTab === '#tab_design_library_variations') {
        Utils.createAndShowTab('#tab_variations');
      }

      if (__this.activeTab === '#tab_your_brand') {
        Utils.createAndShowTab('#tab_design_library_your_brand');
      }

      if (__this.activeTab === '#tab_variations') {
        Utils.createAndShowTab('#tab_design_library_variations');
      }

      console.log(__this.activeTab);
    });


    $(document).off("click.change-design").on("click.change-design", "[data-post-editor-action]", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $this = $(this);
      const action = $this.data('post-editor-action');

      if (action === 'change-design') {
        Utils.createAndShowTab('#tab_your_brand');
        $container.removeClass('with-image-library');
        $container.toggleClass('with-design-library');
        if ($container.hasClass('with-design-library')) {
          await __this.$designLibrary.render();
        } else {

        }
      }

      if (action === 'swap-design') {
        const data = $this.data();
        __this.$postEditor.updateData(data.design, data.src);
      }

      if (action === 'change-image') {
        if(window['subMenu']) {
          const layout = $('[data-layout]');
          if(layout.attr('data-submenu')) {
            layout.removeAttr('data-submenu');
          } else {
            layout.attr('data-submenu', 'active');
          }
        }
        //Utils.createAndShowTab('#tab_image_only');
        $container.removeClass('with-design-library');
        $container.toggleClass('with-image-library');
        $('.hk-pg-wrapper').addClass('editor-with-image-library');
        if ($container.hasClass('with-image-library') && $container.find('.image-library-container').length === 0) {
          const page = _.template(app.templates['post_editor__image-library']);
          const $modal = $(page());
          $modal.appendTo($container);

          const modal = _.template(app.templates['image_library__modal']);
          const $imageModal = $(modal());
          $imageModal.appendTo($modal.find('.image-library-body'));

          const $tabContent = $imageModal.find('.tab-content');

          aimi_image_library.init($tabContent, '.with-image-library', {
            images: {'addButton': true, addButtonText : 'Swap Image'}, collectionsContainerClass: '', imagesContainerClass: ''
          });

          $container.on('click', '.btn-add-to-post', async function (e) {
            const $this = $(this);
            const $item = $this.closest('.infinite-item');
            let imageId = $item.data('id');
            const image = $item.data('org-src');
            const imageThumbnail = $item.data('src');

            const imageData = {};
            imageData.pathThumbnail = image;
            imageData.path = image;
            imageData.id = imageId;
            imageData.config = {images: {'addButton': false}};
            const $image = MyUploads.prepareRow(imageData, 'image_library__image-card');
            const data = __this.$postEditor.getData();

            let requestData = {
              'image': imageThumbnail,
              'pro': {
                'id': data.proTemplateId,
                'svg': data.pro,
              },
              'proHigh': {
                'id': data.proTemplateId,
                'svg': data.proHigh,
              },
              'proplus': {
                'id': data.proPlusTemplateId,
                'svg':data.proplus,
              },
              'proplusHigh': {
                'id': data.proPlusTemplateId,
                'svg':data.proplusHigh,
              },
            };

            const response = await app.apis['post'].svg(data.id, requestData);

            __this.$postEditor.updateData('image', image);
            __this.$postEditor.updateData('pro', response.svgs.pro);
            __this.$postEditor.updateData('proplus', response.svgs.proplus);
            __this.$postEditor.updateData('proHigh', response.svgs.pro);
            __this.$postEditor.updateData('proplusHigh', response.svgs.proplus);

            console.log(__this.$postEditor.getData());

          })

        } else {

        }
      }

      if (action === 'delete-post') {
        const postData = __this.$postEditor.getData();
        app.confirm('Delete Post', 'Are you sure to remove this post from calendar?').then(async function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            const response = await app.apis['post'].delete(postData['id']);
            app.hideModal($modal);
            aimi_post_editor.close();
            app.doButtonReset($button);
            if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
              await aimi_campaign.view.refresh(postData.app_campaign_id);
            } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
              await aimi_article.refresh(app.calendarId);
            } else {
              await aimi_calendar.refresh(app.calendarId);
            }
          }
        })
      }

      if (action === 'save-post') {
        const postData = __this.$postEditor.getData();
        app.doButtonAction($this);
        const response = await app.apis['post'].update(postData);
        aimi_post_editor.close();
        if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
          await aimi_campaign.view.refresh(postData.app_campaign_id);
        } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
          await aimi_article.refresh(app.calendarId);
        } else {
          await aimi_calendar.refresh(app.calendarId);
        }
        app.doButtonReset($this);
      }
    });
  };

  const todoAppTarget = $('.todoapp-wrap');

  const openEditor = function (postId, section) {
    window['subMenu'] = $('.hk-wrapper').attr('data-submenu') === 'active';
    todoAppTarget.addClass('todoapp-info-active');
    aimi_post_editor.init(postId, section);
  }

  aimi_post_editor.open = (postId) => {
    openEditor(postId);
  }

  aimi_post_editor.close = (postId) => {
    $('.post-editor').removeClass('with-image-library');
    $('.post-editor').removeClass('with-design-library');
    $('.hk-pg-wrapper').removeClass('editor-with-image-library');
    todoAppTarget.toggleClass('todoapp-info-active');
  }

  $(document).on("click", ".todoapp-wrap .close-post-info", function (e) {
    todoAppTarget.toggleClass('todoapp-info-active');
    aimi_post_editor.destroy();
    return false;
  });

  $(document).on("click", ".btn-close-design-library", function (e) {
    $('.post-editor').removeClass('with-design-library');
    return false;
  });

  $(document).on("click", ".btn-close-image-library", function (e) {
    $('.post-editor').removeClass('with-image-library');
    $('.hk-pg-wrapper').removeClass('editor-with-image-library');
    return false;
  });

  $(document).on("click", ".todoapp-wrap .edit-post, .todoapp-wrap .view-post, [data-post-action='editor']", function (e) {
    const $target = $(e.target);
    const area = $target.attr('data-editor-area');
    const postId = $target.closest('.post-item').attr('data-id');
    console.log(postId);
    openEditor(postId, area);
  });

}(window.aimi_post_editor = window.aimi_post_editor || {}, jQuery, PreBuilt));
